import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from 'handlebars';

Snappy.Component.Tabs = class Tabs extends Snappy.BaseComponent {
    static get tagName() {
        return 'cfa-tabs';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
        this.setDefaultState();
        if (this.hasDropdown) {
            this.renderDropdown();
        }
    }

    setVars() {
        this.$links = this.$element.find('.js-tab-link');
        this.$tabs = this.$element.find('.js-tab');
        this.checkForUnsavedData = this.$element.is('[data-check-for-unsaved-data]');
        this.unsavedLocalStorage = this.$element.attr('data-check-for-unsaved-data');
        this.hasDropdown = this.$element.is('[data-has-dropdown]');
        this.$dropdownContainer = this.$element.find('[data-dropdown-container]');
    }

    setEventListeners() {
        this.$links.on('click', this.clickProcess.bind(this));
    }

    setDefaultState() {
        let $activeLink = this.$links.filter('.is-active').length
            ? this.$links.filter('.is-active')
            : this.$links.eq(0);
        let target = $activeLink.attr('href').substr(1);

        $activeLink.addClass('is-active');
        $activeLink.attr('aria-selected', 'true');

        this.selectTab(target);
    }

    renderDropdown() {
        let dropdownOptions = [];
        let dropdownTemplate = $('#dropdown-template').html();
        let dropdownTemplateFn = Handlebars.compile(dropdownTemplate);

        this.$links.each((index, link) => {
            dropdownOptions.push({
                selected: false,
                value: link.getAttribute('href').substr(1),
                text: link.textContent
            });
        });

        let dropdownHtml = dropdownTemplateFn(dropdownOptions);

        this.$dropdownContainer.html(dropdownHtml);

        this.$dropdown = this.$element.find('[data-dropdown]');
        this.$dropdown.on('click', this.onDropdownClick.bind(this));
        this.$dropdown.on('change', this.changeProcess.bind(this));
    }

    onDropdownClick(e) {
        this.dropdownPreviousSelection = $(e.target).find('option:selected');
        this.dropdownPreviousValue = $(e.target).val();
    }

    preventClick(target) {
        let targets = JSON.parse(localStorage.getItem(this.unsavedLocalStorage));

        if (targets && typeof targets[target] !== 'undefined') {
            if (targets[target]) {
                if (confirm(targets['unsavedDataWarnMessage'])) {
                    return false;
                } else {
                    return true;
                }
            }
        } else {
            return false;
        }
    }

    clickProcess(e) {
        e.preventDefault();

        let $previousActive = this.$links.filter('.is-active');

        let $previousActiveTarget = $previousActive.attr('href').substr(1);

        let $activeLink = $(e.target);

        if ($activeLink === $previousActive) return;

        let target = $activeLink.attr('href').substr(1);

        if (this.checkForUnsavedData && this.preventClick($previousActiveTarget)) {
            $activeLink.blur();
            return;
        }

        if (this.hasDropdown) {
            this.$dropdown
                .find('option')
                .filter(`[value='${target}']`)
                .prop('selected', true);
        }

        this.changeActiveLink($activeLink);

        this.selectTab(target);
    }

    changeProcess(e) {
        let target = e.target.value;

        if (this.checkForUnsavedData && this.preventClick(this.dropdownPreviousValue)) {
            this.dropdownPreviousSelection.prop('selected', true);
            return false;
        }

        let $activeLink = this.$links.filter(`[href='#${target}']`);

        this.changeActiveLink($activeLink);

        this.selectTab(target);
    }

    changeActiveLink($activeLink) {
        this.$links.removeClass('is-active');
        this.$links.attr('aria-selected', 'false');

        $activeLink.addClass('is-active');
        $activeLink.attr('aria-selected', 'true');
    }

    selectTab(name) {
        let $activeTab = this.$tabs.filter(`[data-target='${name}']`);
        this.$tabs.removeClass('is-active');
        this.$tabs.attr('aria-hidden', 'true');

        $activeTab.addClass('is-active');
        $activeTab.attr('aria-hidden', 'false');
    }
};



// WEBPACK FOOTER //
// ./components/tabs/scripts/tabs.js